import '../../style/index.less';
import './index.less';

// style dependencies
import '../../radio/style';
import '../../checkbox/style';
import '../../dropdown/style';
import '../../spin/style';
import '../../pagination/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/table/style/index.js